import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import moment from "moment";
import { IconButton, Tooltip } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import WorklogManager from "./WorklogManager";
import axios from "axios";
import { useParams } from "react-router";
import StatusLayout from "components/Status";
import AttachmentManager from "./AttachmentManager";
import CommentManager from "./CommentManager";
import SubmitTasks from "../../helpers/SubmitTasks";
import { getMyLineManager } from "../../helpers/Common_functions";

function AssignedTaskManagement({ location, systemSettings, loggedUser, resources }) {
  const mainBackground = systemSettings?.mainBackground;

  const [list, setList] = useState([]);
  const [id, setId] = useState();
  const [count, setCount] = useState(0);
  const [logOpen, setLogOpen] = useState(false);
  const [selected, setSelected] = useState(location.state?.status ?? "all");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [info, setInfo] = React.useState();
  const [attachmentOpen, setAttachmentOpen] = React.useState(false);
  const [task, setTask] = React.useState();
  const [commentOpen, setCommentOpen] = React.useState(false);
  const [processedData, setProcessedData] = React.useState([]);
  const [openSubmitDialog, setOpenSubmitDialog] = React.useState(false);
  const [myLineManager, setMyLineManager] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    const getmyReportingLine = async () => {
      const myLineManager = await getMyLineManager(loggedUser);
      if (myLineManager) {
        setMyLineManager(myLineManager);
      }
    };
    getmyReportingLine();
  }, [loggedUser]);

  const { ids } = useParams();

  const [period, setPeriodState] = React.useState({
    startDate: null,
    endDate: null,
  });

  const updatePeriod = (newPeriod) => {
    setPeriodState(newPeriod);
  };

  const handleSubmitSuccess = () => {
    setCount((v) => v + 1);
  };



  const history = useHistory();

  useEffect(() => {
    setSelected(location.state?.status ?? "all");
  }, [location.state]);

  useEffect(() => {
  }, [myLineManager]);



  const loadData = async () => {
    const resp = await axios.get(
      `api/task/list/assigned?count=${count}`
    );
    // setList(resp.data.data);
    // console.log("resp.data", resp.data);
    setInfo(resp.data);
    return resp.data;
  };

  useEffect(() => {
    loadData();
  }, [id]);

  const columns = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "taskInitiator",
      label: "Initiated By",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const taskData = info?.data[rowIndex];
          const taskInitiatorId = taskData?.initiator;
          const taskInitiatorName = taskData?.taskInitiator?.names || "Unknown";
          const isMe = loggedUser?.Resource?.id === taskInitiatorId;
          return isMe ? "Me" : taskInitiatorName;
        },
      },
    },

    {
      name: "id",
      label: "Comments",
      options: {
        customBodyRender: (value, tableMeta) => {
          const currentTask =
            list && list?.length && list?.find((v) => v.id === value);

          return (
            <div className="flex flex-row gap-4 ">

              {currentTask?.task_comments?.length > 0 && (
                <Tooltip
                  onClick={() => { }}
                  onMouseOver={(e) => {
                    e.stopPropagation();

                    e.target.style.cursor = "pointer";
                  }}
                >
                  <div className="relative flex items-center">
                    <span
                      style={{
                        top: "-6px",
                        right: "-7px",
                        padding: "2px",
                        fontSize: "10px",
                        backgroundColor: mainBackground,
                      }}
                      className="absolute  bg-red-600 text-white rounded-full font-bold flex items-center justify-center"
                    >
                      {currentTask?.task_comments?.length ?? 0}
                    </span>
                    <i className="fas fa-comment text-blueGray-500 text-lg"></i>
                  </div>
                </Tooltip>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status} />
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <div className="flex items-center">

            <IconButton
              onClick={() => {
                const task = list.find((item) => item.id === v);

                if (
                  task &&
                  task?.task_assignees?.length > 0 &&
                  task.task_assignees[0].isOpened
                ) {
                  history.push(`/admin/task/${task.id}`);
                } else {
                  // openTask(task?.id).then(() => {
                  history.push(`/admin/task/${task?.id}`);
                  window.location.reload();
                  // });
                }
              }}
            >
              <img
                src={require("../../assets/icons/eye.svg").default}
                alt="Decorative SVG"
                className={
                  " mr-2 text-sm text-blueGray-300"
                }
              />
            </IconButton>

            <IconButton onClick={(e) => {
              e.stopPropagation();
              setId(v); setDeleteOpen(true)
            }}>
              <img
                src={require("../../assets/icons/trash.svg").default}
                alt="Decorative SVG"
                className={
                  " mr-2 text-sm "
                }
              />
            </IconButton>

          </div>
        ),
      },
    },
    {
      name: "isUrgent",
      label: " ",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowData = tableMeta.rowData;
          const isUrgent = rowData[8];
          if (isUrgent) {
            return (
              <Tooltip title="This task is marked as urgent">
                <span
                  style={{
                    backgroundColor: '#f44336',
                    color: '#fff',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    fontSize: '0.75rem',
                  }}
                >
                  Urgent
                </span>
              </Tooltip>
            );
          } else {
            return null;
          }
        },
      },
    },
  ];

  const onSuccess = () => setCount((v) => v + 1);

  const progressStatus = [
    {
      label: "TO-DO",
      value: "to-do",
    },
    {
      label: "Extended",
      value: "extended",
    },
    {
      label: "In Progress",
      value: "in-progress",
    },
    {
      label: "To verify",
      value: "to-verify",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "On-hold",
      value: "on-hold",
    },
    {
      label: "Overdue",
      value: "overdue",
    },
  ];

  return (
    <div className="w-full mb-12 px-4">

      <SubmitTasks
        open={openSubmitDialog}
        onClose={() => setOpenSubmitDialog(false)}
        onSuccess={handleSubmitSuccess}
        SubmitGeneralForm={async (url, formData) => { /* ... */ }}
        startDate={moment(period.startDate).format("YYYY-MM-DD")}
        endDate={moment(period.endDate).format("YYYY-MM-DD")}
        loggedUser={loggedUser}
        resources={resources}
        processData={processedData}
        columns={columns}
        linemanager={myLineManager}
      />

      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/task/delete/${id}`}
      />
      <WorklogManager
        taskId={id}
        open={logOpen}
        setOpen={() => setLogOpen(false)}
      />
      <AttachmentManager
        taskId={id}
        task={task}
        openAttachment={attachmentOpen}
        onClose={() => {
          setAttachmentOpen(false);
        }}
        onSuccess={onSuccess}
      />

      <CommentManager
        taskId={id}
        task={task}
        open={commentOpen}
        setOpen={() => setCommentOpen(false)}
        onClose={() => {
          setCommentOpen(false);
        }}
        onSuccess={onSuccess}
      />

      <DatatableComponent
        order={location.state?.order}

        // onRowClick={(data, { rowIndex }) => {
        //   const task = list[rowIndex];

        //   if (
        //     task &&
        //     task?.task_assignees?.length > 0 &&
        //     task.task_assignees[0].isOpened
        //   ) {
        //     history.push(`/admin/task/${task.id}`);
        //   } else {
        //     // openTask(task?.id).then(() => {
        //     history.push(`/admin/task/${task?.id}`);
        //     window.location.reload();
        //     // });
        //   }
        // }}
        onRowClick={(data, { rowIndex }) => {
          history.push(`/admin/task/${list[rowIndex].id}`);
        }}
        processData={(data) => {
          setList(data.data);
          setProcessedData(data.data);
          return data;
        }}

        elevation={1}
        searchfield={true}
        search={false}
        viewColumns={false}
        // pdf={true}
        raciChart={true}
        columns={columns}
        // title={`List of Assigned Task  ${location.state?.status ? `(Status : ${location.state?.status})` : ""
        //   }`}

        onRaciChart={() => {
          setOpenSubmitDialog(true);
        }}

        url={`/api/task/list/assigned?count=${count}&status=${selectedStatus}${period.startDate && period.endDate
          ? `&period=${JSON.stringify(period)}`
          : ""
          }`}
        title={
          <div className="flex gap-4 items-center">
            {/* From Date */}
            <div className="flex items-center gap-2">
              <label className="text-[#054163] font-medium">From</label>
              <input
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                type="date"
                value={
                  Date.parse(period?.startDate)
                    ? moment(period?.startDate).format("YYYY-MM-DD")
                    : ""
                }
                max={period.endDate}
                onChange={(e) => {
                  updatePeriod({
                    ...period,
                    startDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                  });
                }}
              />
            </div>

            {/* To Date */}
            <div className="flex items-center gap-2">
              <label className="text-[#054163] font-medium">To</label>
              <input
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                type="date"
                value={
                  Date.parse(period?.endDate)
                    ? moment(period?.endDate).format("YYYY-MM-DD")
                    : ""
                }
                min={moment(period?.startDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  updatePeriod({
                    ...period,
                    endDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                  });
                }}
              />
            </div>

            <select
              className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
              value={selectedStatus}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
              }}
            >
              <option value="">Select Status</option>
              {progressStatus.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
        }
        options={{
          setRowProps: () => {
            return {
              style: {
                backgroundColor: "#4caf50",
              },
            };
          },
        }}
        info={info}
      />
    </div>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignedTaskManagement);
